/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateLetter model module.
 * @module model/CandidateLetter
 * @version v1
 */
class CandidateLetter {
    /**
     * Constructs a new <code>CandidateLetter</code>.
     * Carta de presentacion para incluir en la candidatura. El alumno tiene varias. El titulo solo lo ve el alumno. [P_A_24]
     * @alias module:model/CandidateLetter
     */
    constructor() { 
        
        CandidateLetter.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateLetter</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateLetter} obj Optional instance to populate.
     * @return {module:model/CandidateLetter} The populated <code>CandidateLetter</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateLetter();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateLetter.prototype['id'] = undefined;

/**
 * @member {String} name
 */
CandidateLetter.prototype['name'] = undefined;

/**
 * @member {String} text
 */
CandidateLetter.prototype['text'] = undefined;






export default CandidateLetter;

